import { inject, Injectable } from '@angular/core';
import { Store } from '@fc-core/store-utils/store';
import { ChatChannelsApiService } from '../services/chat-channels-api.service';
import { Channel } from '../models/channel';

export interface ChatChannelState {
  channels: Channel[];
  messagesLoading: boolean;
  online: string[];
  lastSeen: { [id: string]: string };
}

const initialState: ChatChannelState = {
  channels: [],
  messagesLoading: false,
  online: [],
  lastSeen: {},
};

@Injectable({ providedIn: 'root' })
export class ChatChannelStore extends Store<ChatChannelState> {
  api = inject(ChatChannelsApiService);
  constructor() {
    super(initialState);
  }

  async getChannels(): Promise<Channel[]> {
    const channels = await this.api.getChannels();
    this.draftUpdate((draft) => (draft.channels = channels));
    return channels;
  }

  async getChannelById(channelId: string): Promise<Channel> {
    const channel = await this.api.getChannelById(channelId);
    this.updateChannel(channel);
    return channel;
  }

  async setChannelPinned(channelId: string, pinned: boolean): Promise<void> {
    const channel = this.selectors
      .channels()
      .find((storedChannel) => storedChannel.id === channelId);
    if (!channel?.config?.id) return;
    const config = await this.api.updateChannelConfig(channel.config.id, {
      pinned,
    });
    this.updateChannel({ ...channel, config });
  }

  addChannel(channel: Channel): void {
    this.draftUpdate((draft) => draft.channels.push(channel));
  }

  updateChannel(channel: Channel): void {
    this.draftUpdate((draft) => {
      const index = draft.channels.findIndex((c) => c.id === channel.id);
      if (index !== -1) {
        draft.channels[index] = channel;
      } else {
        draft.channels.push(channel);
      }
    });
  }

  setOnline(online: string[]): void {
    if (!online) return;
    this.draftUpdate((draft) => {
      draft.online = online;
    });
  }

  setLastSeen(employees_offline: { id: string; disconnect: string }[]): void {
    if (!employees_offline) return;
    this.draftUpdate((draft) => {
      employees_offline.forEach((employee) => {
        draft.lastSeen[employee.id] = employee.disconnect;
      });
    });
  }

  deleteChannel(channelId: string): void {
    this.draftUpdate((draft) => {
      draft.channels = draft.channels.filter(
        (channel) => channel.id !== channelId,
      );
    });
  }
}
